import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { TYPE_OF_BUSINESS } from "../constants/index.js";

const RegisterUser = ({
  config,
  onChange,
  handleClick,
  show,
  handleRegister,
  errors,
  setErrors,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <Flex
        minH={"100vh"}
        align={"center"}
        justify={"center"}
        bg={useColorModeValue("gray.50", "gray.800")}
      >
        <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
          <Stack align={"center"}>
            <Heading fontSize={"4xl"} textAlign={"center"}>
              Sign up
            </Heading>
            <Text fontSize={"lg"} color={"gray.600"}>
              to enjoy our partnership ✌️
            </Text>
          </Stack>
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow={"lg"}
            p={8}
          >
            <Stack spacing={4}>
              <HStack>
                <Box>
                  <FormControl
                    id="name"
                    isRequired
                    isInvalid={errors?.name ? true : false}
                  >
                    <FormLabel>Name</FormLabel>
                    <Input
                      type="text"
                      onChange={(e) => {
                        onChange("name", e.target.value);
                      }}
                      value={config.name}
                    />
                    {errors?.name ? (
                      <FormErrorMessage>{errors?.name}</FormErrorMessage>
                    ) : (
                      <></>
                    )}
                  </FormControl>
                </Box>
                <Box>
                  <FormControl
                    id="companyName"
                    isInvalid={errors?.companyName ? true : false}
                  >
                    <FormLabel>Company Name</FormLabel>
                    <Input
                      type="text"
                      onChange={(e) => {
                        onChange("companyName", e.target.value);
                      }}
                      value={config.companyName}
                    />
                    {errors?.companyName ? (
                      <FormErrorMessage>{errors?.companyName}</FormErrorMessage>
                    ) : (
                      <></>
                    )}
                  </FormControl>
                </Box>
              </HStack>
              <FormControl
                id="typeOfBusiness"
                isInvalid={errors?.typeOfBusiness ? true : false}
                isRequired={true}
              >
                <FormLabel>Type of Business</FormLabel>
                <Select
                  placeholder="Select option"
                  onChange={(obj) => {
                    onChange("typeOfBusiness", obj.target.value);
                  }}
                >
                  {Object.keys(TYPE_OF_BUSINESS).map((option) => (
                    <option value={option}>{TYPE_OF_BUSINESS[option]}</option>
                  ))}
                </Select>
                {errors?.typeOfBusiness ? (
                  <FormErrorMessage>{errors?.typeOfBusiness}</FormErrorMessage>
                ) : (
                  <></>
                )}
              </FormControl>
              <FormControl
                id="phone"
                isRequired
                isInvalid={errors?.phone ? true : false}
              >
                <FormLabel>Phone Number</FormLabel>
                <Input
                  type="number"
                  onChange={(e) => {
                    onChange("phone", e.target.value);
                  }}
                  value={config.phone}
                />
                {errors?.phone ? (
                  <FormErrorMessage>{errors?.phone}</FormErrorMessage>
                ) : (
                  <></>
                )}
              </FormControl>
              <FormControl
                id="email"
                isRequired
                isInvalid={errors?.email ? true : false}
              >
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  onChange={(e) => {
                    onChange("email", e.target.value);
                  }}
                  value={config.email}
                />
                {errors?.email ? (
                  <FormErrorMessage>{errors?.email}</FormErrorMessage>
                ) : (
                  <></>
                )}
              </FormControl>
              <FormControl
                id="password"
                isRequired
                isInvalid={errors?.password ? true : false}
              >
                <FormLabel>Password</FormLabel>
                <InputGroup>
                  <Input
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => {
                      onChange("password", e.target.value);
                    }}
                    value={config.password}
                  />
                  <InputRightElement h={"full"}>
                    <Button
                      variant={"ghost"}
                      onClick={() =>
                        setShowPassword((showPassword) => !showPassword)
                      }
                    >
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
                {errors?.password ? (
                  <FormErrorMessage>{errors?.password}</FormErrorMessage>
                ) : (
                  <></>
                )}
              </FormControl>
              <Stack spacing={10} pt={2}>
                <Button
                  loadingText="Submitting"
                  size="lg"
                  bg={"black"}
                  color={"white"}
                  _hover={{
                    bg: "gray.600",
                    boxShadow: "lg",
                  }}
                  onClick={handleRegister}
                >
                  Sign up
                </Button>
              </Stack>
              <Stack pt={6}>
                <Text align={"center"}>
                  Already a user?{" "}
                  <Link to="/login" style={{ color: "blue" }}>
                    Login
                  </Link>
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </>
  );
};

export default RegisterUser;
